import { InstrumentType } from '@cash-web/protos/squareup/common/instrument.pb'
import { Instrument } from '@cash-web/protos/squareup/franklin/api/instrument.pb'
import { PasscodeVerificationBlocker } from '@cash-web/protos/squareup/franklin/blockers/passcode_blockers.pb'

export function getPasscodeLength(instrument: Instrument): number {
  const isAmex = instrument && instrument.card_brand === InstrumentType.AMERICAN_EXPRESS
  const instrumentToken = instrument.token || instrument.cash_instrument_type
  const isCustomerPasscode = instrumentToken === 'CUSTOMER_PASSCODE' || instrumentToken === 'CASH_BALANCE'
  const isFourDigitPasscode = isAmex || isCustomerPasscode

  return isFourDigitPasscode ? 4 : 3
}

export function getPasscodeVerificationLength(blocker: PasscodeVerificationBlocker): number {
  const instrument: Instrument = { ...blocker.instrument }
  if (blocker.brand != null) {
    instrument.card_brand = blocker.brand
  }
  return getPasscodeLength(instrument)
}
